import { Colors, Services, isEmpty } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, sizes } from '@/utils'

import button from '@/components/button'
import buttonConfirmRemove from '@/components/button/confirm/remove'
import arrow from '@/components/misc/arrow'
import tab from '@/components/services/eventsHistory/tab'
import templatesForm from '@/components/services/templates/form'
import tag from '@/components/tag'
import date from '@/components/templates/service/item/date'
import overflow from '@/components/text/overflow'

function renderTitle(h) {
  return h(
    'div',
    {
      class: `${Services.templates}-panel__title`
    },
    [
      h(
        overflow,
        {
          props: {
            value: this.value.title
          }
        }
      )
    ]
  )
}
function renderType(h) {
  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${Services.sendings}.types.${this.value.type}`),
        size: sizes.small,
        color: Colors[this.value.type],
        tooltip: this.getTranslate(
          `${Services.templates}.tooltips.type`,
          { type: this.getTranslate(`${Services.sendings}.types.${this.value.type}`) }
        )
      }
    }
  )
}
function renderSendername(h) {
  const { sender } = this.value?.payload
  if (!isEmpty(sender)) {
    return h(
      tag,
      {
        props: {
          label: sender,
          size: sizes.small,
          tooltip: this.getTranslate(`${Services.templates}.tooltips.sender`, { sender })
        }
      }
    )
  }
}
function renderText(h) {
  const { text } = this.value?.payload
  if (!isEmpty(text)) {
    if (this.viewport.size.width >= 600) {
      return h(
        tag,
        {
          props: {
            label: text,
            size: sizes.small,
            color: Colors.grey,
            tooltip: this.getTranslate(`${Services.templates}.tooltips.text`, { text })
          }
        }
      )
    }
  }
}
function renderTags(h) {
  return h(
    'div',
    {
      class: `${Services.templates}-panel__tags`
    },
    [

      renderType.call(this, h),
      renderSendername.call(this, h),
      renderText.call(this, h)
    ]
  )
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: `${Services.templates}-panel__info`
    },
    [
      renderTitle.call(this, h),
      renderTags.call(this, h)
    ]
  )
}
function renderApplyButton(h, showIcon = false) {
  let applyIcon
  let applyLabel
  let applyTooltip
  if (showIcon) {
    applyIcon = icons.launch
    applyTooltip = this.getTranslate(`${Services.templates}.buttons.apply`)
  } else {
    applyLabel = this.getTranslate('misc.buttons.apply')
  }

  return h(
    button,
    {
      class: 'hover-child',
      props: {
        icon: applyIcon,
        label: applyLabel,
        mode: buttonModes.flat,
        color: Colors.primary,
        tooltip: applyTooltip,
        disabled: this.applyDisabled
      },
      on: {
        click: this.applyHandler
      }
    }
  )
}
function renderCratedAt(h) {
  if (this.viewport.size.width > 420) {
    return h(
      date,
      {
        props: {
          value: this.value
        }
      }
    )
  }
}
function renderArrow(h, expanded) {
  return h(arrow, { props: { expanded } })
}
function renderHeader(h, expanded) {
  return h(
    'div',
    {
      class: {
        ['service-template-item']: true,
        ['hover-parent hover-parent--opacity']: this.viewport.breakpoint.mdUp,
        [`${Services.templates}-panel`]: true
      }
    },
    [
      renderInfo.call(this, h),
      renderApplyButton.call(this, h, true),
      renderCratedAt.call(this, h),
      renderArrow.call(this, h, expanded)
    ]
  )
}

function renderForm(h) {
  return h(
    templatesForm,
    {
      props: {
        value: this.proxy
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
function renderEventsHistoryHeader(h, expanded) {
  return h(
    'div',
    {
      class: 'service-template-item'
    },
    [
      h(
        tag,
        {
          props: {
            label: this.getTranslate(`${Services.eventsHistory}.labels.eventsHistory`)
          }
        }
      ),

      renderArrow.call(this, h, expanded)
    ]
  )
}
function renderEventsHistoryContent(h) {
  return h(
    tab,
    {
      props: {
        entityId: this.value.id
      }
    }
  )
}
function renderEventHistory(h) {
  return h(
    components['expansion-panels'],
    {
      props: {
        flat: true,
        outline: true,
        rounded: true
      }
    },
    [
      h(
        components['expansion-panel'],
        {
          scopedSlots: {
            header: ({ expanded }) => {
              return renderEventsHistoryHeader.call(this, h, expanded)
            },
            default: () => {
              return renderEventsHistoryContent.call(this, h)
            }
          }
        }
      )
    ]
  )
}
function renderUpdateButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.update'),
        color: Colors.primary,
        loading: this.loading,
        disabled: this.updateDisabled
      },
      on: {
        click: this.updateHandler
      }
    }
  )
}
function renderActions(h) {
  return h(
    'div',
    {
      class: `${Services.templates}-panel__footer-actions`
    },
    [
      renderUpdateButton.call(this, h),
      renderApplyButton.call(this, h)
    ]
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: `${Services.templates}-panel__footer`
    },
    [
      h(
        buttonConfirmRemove,
        {
          props: {
            labeled: false,
            callback: this.removeHandler
          }
        }
      ),

      renderActions.call(this, h)
    ]
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${Services.templates}-panel__body`
    },
    [
      renderForm.call(this, h),
      renderEventHistory.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components['expansion-panel'],
    {
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, expanded)
        },
        default: () => {
          return renderBody.call(this, h)
        }
      }
    }
  )
}
